import React, { useEffect, useState } from "react";

import {
    container,
    button,
    favoriteButton,
    favoriteButtonActive,
    padlock,
    buttonContent,
    cardFooter,
    brandBox,
    desktopCard,
    desktopImageWrapper,
    desktopImage,
    desktopMeta,
    desktopCategory,
    desktopBrand,
    desktopActions,
    desktopZoom,
    desktopZoomIcon,
    unavailable,
    unavailableBadge,
    tryOnButton,
    tryOnButtonReady,
    tryOnButtonLoading,
} from "./product-card.module.scss";
import useUser from "../../../apps/auth/hooks/use-user";
import { IProduct } from "../../../models/product.model";
import { postProductStatistic } from '../../../services/product-services';
import {
    getFavoriteProductIds,
    toggleFavoriteProduct,
} from "../../../services/product-favorites-services";
import Padlock from "../../../components/molecules/padlock";
import ViewIcon from "../../../assets/images/svg/view.svg";
import favoriteIcon from "../../../assets/icons/favorite.svg";

interface IProductCardProps {
    className?: string;
    classNameButtonContent?: string;
    onPadlockClick?: () => void;
    product: IProduct;
    productLength: number;
    isLocked?: boolean;
    nameProduct?: string;
    optionsProduct?: any[];
    labelProduct?: string;
    classNameProduct?: string;
    isTablet: boolean;
    showInputs?: boolean;
    readonly?: boolean;
    isMinimal?: boolean;
    productClickCustomFn?: (product: IProduct) => void;
    onLoginRequired?: () => void;
    onTryOn?: (productId: number) => void;
    tryOnState?: "idle" | "loading" | "ready";
    tryOnEnabled?: boolean;
}

const ProductCard: React.FC<IProductCardProps> = ({
    className = "",
    classNameProduct = "",
    classNameButtonContent = "",
    onPadlockClick,
    product,
    productLength,
    isLocked,
    nameProduct = "",
    optionsProduct = [],
    labelProduct = "",
    isTablet,
    productClickCustomFn = () => {},
    showInputs = false,
    readonly = false,
    isMinimal = false,
    onLoginRequired,
    onTryOn,
    tryOnState = "idle",
    tryOnEnabled = false,
}) => {
    const { category, imgUrl, url, affiliateUrl, brandName, typeClothes, color } = product;
    const isDesktopFull = !isTablet && !isMinimal;
    const showUnavailable = readonly && (product.isAvailable === false || product.availabilityStatus === 2);
    const [isFavorite, setIsFavorite] = useState(false);
    const [isFavoriteSaving, setIsFavoriteSaving] = useState(false);

    //console.log("Product imgUrl", imgUrl);

    const { isLoggedIn } = useUser();

    useEffect(() => {
        let isMounted = true;
        if (!isLoggedIn || !product.productId) {
            setIsFavorite(false);
            return () => {
                isMounted = false;
            };
        }

        getFavoriteProductIds()
            .then((ids) => {
                if (isMounted) {
                    setIsFavorite(ids.has(Number(product.productId)));
                }
            })
            .catch(() => {
                if (isMounted) {
                    setIsFavorite(false);
                }
            });

        return () => {
            isMounted = false;
        };
    }, [isLoggedIn, product.productId]);

    const handlePadlockClick = () => {
        if (!isLoggedIn) {
            if (typeof onLoginRequired === "function") {
                onLoginRequired();
            }
            return;
        }

        if (typeof onPadlockClick === "function") {
            onPadlockClick();
        }
    };

    const handleLinkClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if (readonly) {
            return;
        }
        if (event.target instanceof HTMLDivElement) {
            if (typeof productClickCustomFn === "function") {
                productClickCustomFn(product);
            }
            else {
                postProductStatistic(product);
                const url = affiliateUrl || product.url;
                if (url) {
                    window.open(url, '_blank');
                }
            }
        }
        //href={affiliateUrl || url} target={'_blank'} 
    }

    const handleTryOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        if (!isLoggedIn) {
            if (typeof onLoginRequired === "function") {
                onLoginRequired();
            }
            return;
        }
        if (product.productId && typeof onTryOn === "function") {
            onTryOn(Number(product.productId));
        }
    };

    const handleFavoriteClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();

        if (!isLoggedIn) {
            if (typeof onLoginRequired === "function") {
                onLoginRequired();
            }
            return;
        }

        if (!product.productId || isFavoriteSaving) {
            return;
        }

        setIsFavoriteSaving(true);
        const previousValue = isFavorite;
        setIsFavorite(!previousValue);
        try {
            const nextValue = await toggleFavoriteProduct(Number(product.productId));
            setIsFavorite(nextValue);
        } catch {
            setIsFavorite(previousValue);
        } finally {
            setIsFavoriteSaving(false);
        }
    };

    return (
        // style={{ backgroundImage: `url(${imgUrl})`, flex: `0 0 ${100 / productLength}%` }} <= flex w zaleznosci od ilosci produktow
        <>
            {/*   */}
            <div
                onClick={(event) => handleLinkClick(event)}
                className={`${container} ${isDesktopFull ? desktopCard : ""} ${showUnavailable ? unavailable : ""} ${className}`}
                style={
                    isDesktopFull
                        ? undefined
                        : {
                              backgroundImage: `url("${imgUrl}")`,
                              flex: isMinimal ? `0 0 ${Math.round(100 / productLength)}%` : `0 0 33%`,
                          }
                }
            >

                {/* <img src={imgUrl} /> */}
                {/* {!isTablet && showInputs && isLoggedIn && <SwitchInput
                    key={product.productId}
                    className={classNameProduct}
                    productLength={productLength}
                    name={nameProduct}
                    options={optionsProduct}
                    label={labelProduct}
                />} */}
                {
                    isTablet && showInputs && isLoggedIn && <div></div>
                }
                {
                    !showInputs && <div></div>
                }
                {
                    !isLoggedIn && <div></div>
                }
                {onPadlockClick && (
                    <Padlock
                        onClick={handlePadlockClick}
                        className={padlock}
                        isLocked={Boolean(isLocked)}
                        tourTarget="lock"
                        ariaLabel={
                            isLocked
                                ? "Odblokuj ten element stylizacji"
                                : "Zablokuj ten element stylizacji"
                        }
                    />
                )}
                {product.productId && !isMinimal && tryOnEnabled && (
                    <button
                        type="button"
                        className={`${tryOnButton} ${
                            tryOnState === "ready" ? tryOnButtonReady : ""
                        } ${tryOnState === "loading" ? tryOnButtonLoading : ""}`}
                        onClick={handleTryOnClick}
                        disabled={tryOnState === "loading"}
                        aria-label={
                            tryOnState === "ready"
                                ? "Pokaż gotowy ubiór"
                                : tryOnState === "loading"
                                    ? "Trwa przymierzanie ubrania"
                                    : "Załóż to ubranie"
                        }
                        title={
                            tryOnState === "ready"
                                ? "Pokaż gotowy ubiór"
                                : tryOnState === "loading"
                                    ? "Przymierzanie..."
                                    : "Załóż ubranie"
                        }
                    >
                        <span aria-hidden="true">{tryOnState === "ready" ? "✓" : "👚"}</span>
                    </button>
                )}
                {product.productId && !isMinimal && (
                    <button
                        type="button"
                        className={`${favoriteButton} ${isFavorite ? favoriteButtonActive : ""}`}
                        onClick={handleFavoriteClick}
                        disabled={isFavoriteSaving}
                        aria-pressed={isFavorite}
                        aria-label={isFavorite ? "Usuń produkt z ulubionych" : "Dodaj produkt do ulubionych"}
                    >
                        <img src={favoriteIcon} alt="" aria-hidden="true" />
                    </button>
                )}
                {showUnavailable && <div className={unavailableBadge}>Niedostępne</div>}
                {isDesktopFull && (
                    <>
                        <div className={desktopImageWrapper}>
                            <img src={imgUrl} className={desktopImage} alt={category || "Produkt"} />
                        </div>
                        <div className={desktopMeta}>
                            <p className={desktopBrand}>{product.brandName}</p>
                        </div>
                        {!readonly && (
                            <a
                                href={affiliateUrl || url}
                                className={desktopZoom}
                                target={"_blank"}
                                rel="noopener noreferrer"
                                onClick={() => {
                                    postProductStatistic(product);
                                }}
                                aria-label="Przejdź do produktu"
                            >
                                <ViewIcon className={desktopZoomIcon} aria-hidden />
                            </a>
                        )}
                    </>
                )}
                {!readonly && (
                    <div className={`${cardFooter} ${isDesktopFull ? desktopActions : ""}`}>
                        {!isDesktopFull && !isTablet && !isMinimal && brandName ? (
                            <div className={brandBox}>{brandName}</div>
                        ) : null}
                        {isMinimal && !isTablet && <div className={brandBox}>{typeClothes} {color}</div>}
                        <div className={`${classNameButtonContent} ${buttonContent}`}>
                            <a
                                href={affiliateUrl || url}
                                className={button}
                                target={"_blank"}
                                rel="noopener noreferrer"
                                onClick={() => {
                                    postProductStatistic(product);
                                }}
                            >
                                <h2>Sprawdź dostępność</h2>
                            </a>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ProductCard;
